export function getPublishingTasksCheckDescription(
  isPublishedIntegration: boolean
) {
  if (isPublishedIntegration) {
    return 'Blocking issues that should‘ve been addressed before your integration was included in the App Directory.';
  }
  return 'Blocking issues that must be addressed before your integration can be included in the App Directory.';
}

/*
 * Different messages for different scenarios of a combination of these
 * parameters
 *
 * - integataion status: published (beta & public) or private
 * - version status: public or private
 * - intention: public or private
 *
 * Let's enumerate them.
 *
 * A public version of a published integration with a public intention:
 *   "Non blocking issues and recommendations that will improve the quality of your integration."
 *
 *   A public version is locked and read-only. Integration builders can't
 *   update the version. We only show the message to share the warnings.
 *
 * A public version of a published integration with a private intention:
 *   "Non-blocking issues and recommendations that will improve the quality of your integration."
 *
 *   A public version is locked and read-only. Integration builders can't
 *   update the version. We only show the message to share the warnings.
 *
 * A public version of a private integration with a public intention:
 *   "Non-blocking issues and recommendations that will improve the quality of your integration."
 *
 *   This shouldn't be reached. A public version shouldn't reside in a
 *   private integration. We show the message anyways.
 *
 * A public version of a private integration with a private intention:
 *   "Non-blocking issues and recommendations that will improve the quality of your integration."
 *
 *   This shouldn't be reached. A public version shouldn't reside in a
 *   private integration. We show the message anyways.
 *
 * A private version of a published integration with a public intention:
 *   "Non-blocking issues and recommendations that need to be reviewed before promoting this version of your integration."
 *
 *   We show the message only in this scenario to indicate what to pay
 *   attention to before promoting this version.
 *
 * A private version of a published integration with a private intention:
 *   "Non-blocking issues and recommendations that need to be reviewed before promoting this version of your integration."
 *
 *   This shouldn't be reached. A published integration shouldn't have a
 *   private intention. We show the message in this only scenario anyways to
 *   indicate what to pay attention to before promoting this version.
 *
 * A private version of a private integration with a public intention:
 *   "Non-blocking issues and recommendations that need to be reviewed by Zapier before publishing your integration."
 *
 * A private version of a private integration with a private intention:
 *   "Non-blocking issues and recommendations that will improve the quality of your integration"
 *
 * To simplify them, given the parameters we shows these messages
 *
 *   "Non-blocking issues and recommendations that need to be reviewed before promoting this version of your integration."
 *     for a private version of a published integration;
 *   "Non-blocking issues and recommendations that need to be reviewed by Zapier before publishing your integration."
 *     for a private version of a private integration with a public intention;
 *   "Non-blocking issues and recommendations that will improve the quality of your integration."
 *     otherwise;
 */
export function getWarningCheckDescription(
  isPublishedIntegration: boolean,
  isPublicVersion: boolean,
  isPublicIntention: boolean
) {
  if (isPublishedIntegration && !isPublicVersion) {
    return 'Non-blocking issues and recommendations that need to be reviewed before promoting this version of your integration.';
  }
  if (!isPublishedIntegration && !isPublicVersion && isPublicIntention) {
    return 'Non-blocking issues and recommendations that need to be reviewed by Zapier before publishing your integration.';
  }
  return 'Non-blocking issues and recommendations that will improve the quality of your integration.';
}
